import vconst from "utils/helpers/structs/vconst";
import TableEmptyRow from "components/others/TableEmptyRow";
import { UserNameItem } from 'modules/user';
import { useObjectCard } from "../../context/ObjectCardProvider";
import { DateTime as DT } from "luxon";
import ExpendTeamActions from "./ExpendTeamActions";
import useChangeDate from "hooks/useChangeDate";
import { useRef } from "react";
import * as apiObject from "api/apiObjects";
import { useTranslation } from "react-i18next";
import { useToast } from "context/ToastContext";
import { CountBadge, ProductOperPrice } from 'modules/warehouse';
 
const ExpendTeamTableBody = ({setShowSpinnerExpendTeam, setShowExpendInfo}) => {

    const { t } = useTranslation(['Objects']);
    const { showToast } = useToast();
    const { vObject, fetchObject, setShowSpinner } = useObjectCard();
    const { changeDate } = useChangeDate();
    const refExpendId = useRef();

    const handleClickDate = async (newExpendDate) => {
        setShowSpinner(true);
        const resExpendDate = await apiObject.setExpendTeamDate(refExpendId.current, newExpendDate);
        if (!resExpendDate) showToast(t('common:messError'), 'danger');
        await fetchObject();
        
    } 
 
    return (
        <tbody>
            {vObject?.expendTeams?.map(expend=>{
                const dt = DT.fromMillis(expend.dt||0).toLocaleString(DT.DATE_MED);
                const dtCancel = DT.fromMillis(expend.dtCancel||0).toLocaleString(DT.DATE_MED);
                const serviceName = expend.income_name || expend.incomeName || '';
                const count = Number(expend.income_count ?? expend.incomeCount ?? 1) || 1;
                const priceOp = {
                    operPrice: Number(expend.income_price ?? expend.incomePrice ?? expend.income_amount ?? 0),
                    operPriceRate: Number(expend.income_price_rate ?? expend.incomePriceRate ?? expend.income_amount_rate ?? 0),
                    operPriceSale: Number(expend.income_price_sale ?? expend.incomePriceSale ?? 0),
                    operPriceSaleRate: Number(expend.income_price_sale_rate ?? expend.incomePriceSaleRate ?? 0),
                };
                return (
                    <tr className={`${expend.income_status === vconst.incomeStatCancel ? 'bg-light-danger' :''}`}
                        key={expend.ID}>
                        <td className="user">
                            <UserNameItem 
                                user={{
                                    userName       : expend.user_name,
                                    userEmail      : expend.user_email,
                                    userPicture    : expend.user_picture
                                }}/> 
                        </td>
                        <td className="service">
                            <h6 className="mb-1 text-break">{serviceName || '—'}</h6>
                            <p className="text-muted f-12 mb-0 my-1 text-truncate">{expend.team_name || t('fieldsService.noTeam')}</p>
                            <div className="d-md-none">
                                <p className="text-muted f-12 mb-0 my-1">{dt} </p>
                            </div>
                        </td>
                        <td className="date">
                            <h6 className="mb-1 text-break cursor-pointer"
                                onClick={(e)=>{
                                    if (e.ctrlKey) {
                                        refExpendId.current = expend.ID;
                                        changeDate(expend.dt, handleClickDate) 
                                    }
                                }}>{dt}</h6>
                            {expend.income_status === vconst.incomeStatCancel && 
                            (<p className={`text-danger fw-medium fs-12 mb-0 my-1 text-truncate`}>{dtCancel}</p>)}
                        </td>
                        <td className="price">
                            <ProductOperPrice showSalePrice operation={priceOp}/>
                            <div className="d-block d-md-none mt-2">
                                <CountBadge fs={12} count={count}/>
                            </div>
                        </td>
                        <td className="count text-truncate">
                            <CountBadge fs={14} count={count}/>
                        </td>
                        <td className="actions">
                            <ExpendTeamActions
                                setShowExpendInfo={setShowExpendInfo}
                                setShowSpinnerExpendTeam={setShowSpinnerExpendTeam}
                                expend={expend}/>
                        </td>
                    </tr>
                )
            })}

            {vObject?.expendTeams?.length === 0 && (
                <TableEmptyRow colSpan={6} />
            )}
        </tbody>
    )
}

export default ExpendTeamTableBody;
